<template>
  <TableLayout :permissions="['business:sites:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="站点编号" prop="siteId">
        <el-input v-model="searchForm.siteId" placeholder="请输入站点编号" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="站点名称" prop="siteName">
        <el-input v-model="searchForm.siteName" placeholder="请输入站点名称" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="锁止器号" prop="lockId">
        <el-input v-model="searchForm.lockId" type="number" placeholder="请输入站点名称" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="是否有车" prop="hasBike">
        <el-select v-model="searchForm.hasBike" placeholder="请选择">
          <el-option
            label="全部"
            :value="0">
          </el-option>
          <el-option
            label="无车"
            :value="1">
          </el-option>
          <el-option
            label="有车"
            :value="2">
          </el-option>
        </el-select>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        border
      >
        <el-table-column prop="siteId" label="站点编号" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="siteName" label="站点名称" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="lockId" label="锁止器号" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="code" label="当前在架车辆" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="paramName" label="车辆类型" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="editDate" label="最后通讯时间" min-width="100px" align="center"></el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
export default {
  name: 'Sites',
  extends: BaseTable,
  components: { TableLayout, Pagination },
  data () {
    return {
      // 搜索
      searchForm: {
        siteName: '',
        siteId: '',
        lockId: '',
        hasBike: 0,
      }
    }
  },
  created () {
    this.config({
      module: '站点信息表',
      api: '/business/bikeLocation',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  }
}
/**
 *
 */
</script>
